export const UTC_WITHOUT_TZ = 'YYYY-MM-DD[T]HH:mm:ss';
export const DATE_WITHOUT_TIME = 'YYYY-MM-DD';
export const DATE_WITH_TIME = 'YYYY-MM-DD, HH:mm';
export const READABLE_DATE = 'd MMMM YYYY';
export const TIME_ONLY = 'HH:mm';
export const LONG_DATE_WITH_TIME = 'd MMMM YYYY, HH:mm';

export const BOOKING_TIME_FORMAT = 'ddd, D MMMM HH:mm';
